import { gql } from '@apollo/client';

export const LIKED_UNLIKED_SPONSOR = gql`
  mutation MyMutation($isLiked: Boolean!, $id: Int!, $model: String!) {
    likeOrDislikeSponsor(isLiked: $isLiked, id: $id, model: $model)
  }
`;

export const JOIN_LEAVE_SPONSOR = gql`
  mutation MyMutation($joinCommunity: Boolean!, $id: Int!) {
    joinOrLeaveSponsor(joinCommunity: $joinCommunity, id: $id)
  }
`;

export const ADD_JOIN_CONVERSATION = gql`
  mutation ADDJOINCONVERSATION($conversation:ConversationInput) {
    postJoinConversation(conversation:$conversation)
  }
`;
